// extracted by mini-css-extract-plugin
module.exports = {"footer":"TheFooter_footer_2C792"};